export enum MenuTitleCaptionPosition {
  TOP = "top",
  BOTTOM = "bottom",
  CENTER = "center"
}
